import { render, staticRenderFns } from "./VBtnGroup.vue?vue&type=template&id=19bafdf4&lang=pug"
import script from "./VBtnGroup.vue?vue&type=script&lang=js"
export * from "./VBtnGroup.vue?vue&type=script&lang=js"
import style0 from "./VBtnGroup.vue?vue&type=style&index=0&id=19bafdf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports